import { useState } from 'react';
import MapModal from './MapModal';
import type { MapReadAddress } from '@/types/mapReadAddress';
import { parseReadOnlyAddress } from '@/utils/addressForMap';

export type ReadOnlyAddressWithMapFieldProps = {
  address?: MapReadAddress | null;
  fieldLabel?: string;
  mapModalTitle?: string;
  fullWidth?: boolean;
  className?: string;
};

const linkClass =
  'text-sm text-blue-600 hover:text-blue-800 hover:underline cursor-pointer text-left';

const ReadOnlyAddressWithMapField = ({
  address,
  fieldLabel = 'Dirección',
  mapModalTitle = 'Ubicación',
  fullWidth = true,
  className = '',
}: ReadOnlyAddressWithMapFieldProps) => {
  const [mapOpen, setMapOpen] = useState(false);
  const { display, neighborhood, mapMarker } = parseReadOnlyAddress(address);

  const rootClass = [fullWidth && 'sm:col-span-2', className].filter(Boolean).join(' ');

  return (
    <div className={rootClass}>
      <span className='block text-xs font-semibold text-gray-500 uppercase tracking-wide mb-1'>
        {fieldLabel}
      </span>
      <div className='flex flex-col'>
        {mapMarker ? (
          <button type='button' onClick={() => setMapOpen(true)} className={linkClass}>
            {display}
          </button>
        ) : (
          <span className='text-sm'>{display}</span>
        )}
        {neighborhood ? (
          <span className='text-xs text-gray-600 mt-1'>{neighborhood}</span>
        ) : null}
      </div>

      {mapMarker ? (
        <MapModal
          open={mapOpen}
          onClose={() => setMapOpen(false)}
          title={mapModalTitle}
          markers={[{ lat: mapMarker.lat, lng: mapMarker.lng, label: mapMarker.label }]}
        />
      ) : null}
    </div>
  );
};

export default ReadOnlyAddressWithMapField;
